module.exports = "<div class=\"booking-form\">\n    <div class=\"form\">\n        <a-dynamic-form [fields]=\"fields\"></a-dynamic-form>\n    </div>\n</div>"